import DashboardHeader from "@/components/DashboardHeader";
import Dropzone from "@/components/dropzone/DropZone";
import { AstericSign, avoidEmptyStringValidator, emailValidator, FormHookInput, FormHookTextArea, Loader, NON_DIGIT_REGEX, slugNameValidator } from "@thdinc/hpf-shared";
// convertCentsToDollars, dollarAmountValidation, numberWithoutDecimal - used by Min/Max Distance + Cost per mile, moved to Pricing Calculator (PriceCalculation.tsx)
import React, { useEffect, useState } from "react";
import { useForm /*, useWatch */ } from "react-hook-form";
import { CompanyInterface, PlacesData } from "../../interface";
import useLoading from "@/hooks/useLoading";
import useError from "@/hooks/useError ";
import "react-select-search/style.css";
import { TIME_ZONES_LIST } from "@/constants/CompanyData";
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import PlacesInput from "@/components/input/PlacesInput";

import SelectSearchInput from "@/components/selectInput/SelectSearchInput";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FaPlay } from "react-icons/fa";
import FormModal from "@/components/modals/FormModal";

// add company interface
interface addCompany {
  businessId?: string;
  isAdmin?: boolean;
  next?: () => void;
  prev?: () => void;
}

// company form interfaces
type CompanyForm = {
  companyName: string;
  address: string;
  address2: string;
  city: string;
  stripeId: string;
  state: string;
  postalCode: string;
  distance: string;
  timezone: string;
  location: string;
  email: string;
  // radius: number; // Max Distance - moved to Pricing Calculator (PriceCalculation.tsx)
  description: string;
  custom_quote_description: string;
  // minRadius: string; // Min Distance - moved to Pricing Calculator (PriceCalculation.tsx)
  // mileageFee: string; // Cost per mile - moved to Pricing Calculator (PriceCalculation.tsx)
  // slugName: string;
  clientUrl: string;
  stripeEmail: string;
  google_review_link: string;
  video?: File | null;
  facebook?: string;
  instagram?: string;
  phone_number?: string;
  place_id?: string;
  data_id?: string;
};
interface FileInterface {
  file: File | null;
  url: string;
}
const CompanyDetail: React.FC<addCompany> = ({ next, businessId }) => {
  const { addCompanyApi, getCompanyApi } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    // control, // used by watchedRadius for Min/Max Distance + Cost per mile, moved to Pricing Calculator (PriceCalculation.tsx)
    formState: { errors },
    trigger,
  } = useForm<CompanyForm>({ defaultValues: { /* radius: 30 */ } });
  const [primaryImage, setPrimaryImage] = useState<FileInterface | null>(null);
  const [logoImage, setLogoImage] = useState<FileInterface | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [imgLoad, setImgLoad] = useState({
    logo: false,
    primary: false,
    others: false,
  });
  const [portfolioImages, setPortfolioImage] = useState<FileInterface[]>([]);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [error, setCustomError] = useError();
  const [selectTimeZone, setSelectTimeZone] = useState<string>("null");
  // const [modal, setModal] = useState<boolean>(false);
  // const [otherImages, setOtherImages] = useState<File[]>([]);
  const [payloadState, setPayloadState] = useState<any | null>(null);
  const [companyData, setCompanyData] = useState<CompanyInterface | null>(null);
  const [place, setPlace] = useState<PlacesData | null>(null);

  // timezone from google places input
  const selectTimeZoneFun = (zone: string) => {
    setSelectTimeZone(zone);
    if (error?.name === "timezone") {
      setCustomError("", "");
    }
  };

  // const watchedRadius = useWatch({ control: control, name: "radius" }); // used by Cost per mile, moved to Pricing Calculator (PriceCalculation.tsx)

  useEffect(() => {
    getData();
  }, []);
const onAddressSelected = (
    address: string,
    lat: number,
    lng: number,
    city: string,
    state: string,
    zip: string,
    timezone: string
  ) => {
    // on address selected google places will provide the details
    if (timezone) {
      // if timezone is available
      setSelectTimeZone(timezone);
    }
    setValue("postalCode", zip ? zip : "");
    setPlace({
      address: address,
      lat: lat,
      lng: lng,
      city: city,
      state: state,
      zip: zip,
    });
    
  };
    useEffect(() => {
      setSelectTimeZone(companyData?.timezone as string);
      setPlace({
        address: companyData?.address1 || "",
        city: companyData?.city || "",
        lat: companyData?.location?.coordinates[1] as number,
        lng: companyData?.location?.coordinates[0] as number,
        state: companyData?.state as string,
        zip: companyData?.postal_code as string,
      });
    }, [companyData]);
  const getData = async () => {
    // in order to get the company data in view type page
    startLoading();
    try {
      const result = await GET(`${getCompanyApi}/${businessId}`, refreshToken);
      //update state for modal
      setCompanyData(result?.data);
      setValue("companyName", result?.data?.name);
      setValue("email", result?.data?.email);
      setValue("address2", result?.data?.address2);
      // setValue("radius", result?.data?.radius); // Max Distance, moved to Pricing Calculator (PriceCalculation.tsx)
      setValue("postalCode", result?.data?.postal_code);
      setValue("description", result?.data?.description);
      setValue("custom_quote_description", result?.data?.custom_quote_description);
      setValue("stripeId", result?.data?.stripe_id);
      // setValue("slugName", result?.data?.slug);
      setValue(
        "clientUrl",
        `${result?.data?.clientUrl}/${result?.data?.slug}/`
      );
      setValue("stripeEmail", result?.data?.stripe_email);
      setValue("facebook", result?.data?.facebook);
      setValue("instagram", result?.data?.instagram);
      setValue("phone_number", result?.data?.phone_number);
      setValue("google_review_link", result?.data?.google_review_link);
      setValue("data_id", result?.data?.data_id);

      // Cost per mile, moved to Pricing Calculator (PriceCalculation.tsx)
      // setValue("mileageFee", convertCentsToDollars(result?.data?.mileage_fee));
      setLogoImage({ file: null, url: result?.data?.logo });
      setPrimaryImage({ file: null, url: result?.data?.open_graph_image });
      setPortfolioImage(
        result?.data?.images.map((image: string) => {
          return { file: null, url: image };
        })
      );
      setVideos(
        result.data.videos.map((vid: string) => {
          return {
            file: null,
            url: vid,
          };
        })
      );
    } catch (err) {
      console.log(String(err));
    } finally {
      stopLoading();
    }
  };

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  // === videos related ===
  const [curVid, setcurVid] = useState<string>("");
  const [videos, setVideos] = useState<FileInterface[]>([]);
  console.log('selectTimeZone',selectTimeZone)
  return (
    <div>
      <div className="flex items-center gap-1">
        <div className="bg-white p-2 rounded-full cursor-pointer">
          <IoMdArrowBack className=" " onClick={() => goBack()} />
        </div>
        <DashboardHeader title={"Business Details"}></DashboardHeader>
      </div>
      <div className="bg-white rounded-2xl shadow-md border p-6  mx-auto">
        {/* images upload */}

        <div className="flex gap-4 flex-col sm:flex-row">
          <div className="w-full ">
            <div className="flex gap-2 justify-center sm:justify-start">
              <div>
                <div className=" font-semibold my-2">Business Logo</div>
                <Dropzone
                  imgLoad={imgLoad.logo}
                  disabled
                  image={logoImage?.url}
                ></Dropzone>
              </div>
              <div className="">
                <div className=" font-semibold my-2">Primary Picture</div>
                <Dropzone
                  disabled
                  imgLoad={imgLoad.primary}
                  image={primaryImage?.url}
                ></Dropzone>
                {error?.name === "dp" && (
                  <p className="text-primary-red ">{error.message}</p>
                )}
              </div>
            </div>
            <div>
              {error?.name === "logo" && (
                <p className="text-primary-red ">{error.message}</p>
              )}
            </div>
          </div>
          <div className="w-full flex gap-2 items-end justify-center sm:justify-start">
            <div>
              <div className=" font-semibold my-2">Portfolio Pictures</div>
              <div className="flex items-center gap-3 flex-wrap">
                {portfolioImages.map((p, index) => {
                  return (
                    <Dropzone
                      disabled
                      key={index}
                      imgLoad={imgLoad.others}
                      image={p.url}
                    // removeImage={() => removeImage("other1", index, p.url)}
                    // onDrop={(e: File) => otherImagesUpload(e, "other1")}
                    ></Dropzone>
                  );
                })}
              </div>

              {error?.name === "other" && (
                <p className="text-primary-red ">{error.message}</p>
              )}
            </div>
          </div>
        </div>
        {/* Videos section - commented out
        <div className="">
          <div className=" font-semibold my-2"> Videos</div>
          <div className="flex items-start gap-3 flex-wrap">

            {videos.length > 0 &&
              videos.map((vid, i) => {
                return (
                  <div key={i}>
                    <div
                      onClick={() => {
                        setcurVid(vid.url);
                        setShowForm(true);
                      }}
                      className="relative overflow-hidden inline-block"

                    >
                      <FaPlay className="absolute text-primary-red  top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 " />
                      <video
                        className="rounded-xl w-full  cursor-pointer  max-h-[150px] "
                        src={vid.url}
                      >
                        Your browser does not support the video tag.
                      </video>
                    </div>

                    <div className="flex justify-end mt-2 cursor-pointer "></div>
                  </div>
                );
              })}
          </div>

          {error?.name === "video" && (
            <p className="text-primary-red ">{error.message}</p>
          )}

          Preview modal
          <FormModal
            modalTitle="Video Preview"
            width="w-full md:w-[550px]"
            isOpen={showForm}
            onClose={() => setShowForm(false)}
          >
            <video
              controls
              className="rounded-xl w-[100vw] cursor-pointer  h-[70vh]"
              src={curVid}
            >
              Your browser does not support the video tag.
            </video>
          </FormModal>
        </div>
        */}
        <form className="flex flex-col gap-5" onSubmit={() => console.log('')}>
          <div className="flex gap-4 flex-col sm:flex-row">
            <div className="w-full ">
              <div className=" font-semibold my-2 ">Business Name <AstericSign/></div>
              <FormHookInput
                disabled
                type="text"
                placeholder="Business Name"
                register={register("companyName", {
                  required: "Business Name is required",
                  pattern: avoidEmptyStringValidator,
                  maxLength: {
                    value: 75,
                    message: "Business Name can't be more than 75 characters.",
                  },
                  onBlur: () => trigger("companyName"),
                  onChange: () => {
                    const regex = /[^a-zA-Z0-9\s]/g;
                    let slugName = getValues("companyName")
                      .trim()
                      .replace(regex, "");
                    slugName = slugName.replace(/\s+/g, " ");
                    // setValue(
                    //   "slugName",
                    //   slugName.toLowerCase().replace(/\s/g, "-")
                    // );
                    setValue(
                      "clientUrl",
                      slugName.toLowerCase().replace(/\s/g, "-")
                    );
                  },
                  // pattern: {
                  //   value: /^[\w\s\.]+$/, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                  //   message: "Invalid first name format",
                  // },
                })}
                error={errors.companyName}
              />
            </div>
            <div className="w-full">
              <div className=" font-semibold my-2 ">Business Email <AstericSign/></div>
              <FormHookInput
                disabled

                type="email"
                placeholder="Business Email"
                register={register("email", {
                  required: "Business Email is required!",
                  pattern: emailValidator,
                  onBlur: () => trigger("email"),
                })}
                error={errors.email}
              />
            </div>
          </div>
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full ">
              {/* <div className=" font-semibold my-2 ">Slug Name <AstericSign/></div>
              <FormHookInput
                disabled

                type="text"
                placeholder="Slug Name"
                register={register("slugName", {
                  maxLength: {
                    value: 75,
                    message: "Slug Name can't be more than 75 characters.",
                  },
                  required: "Slug Name is required!",
                  pattern: slugNameValidator,
                  onBlur: () => trigger("slugName"),
                })}
                error={errors.slugName}
              /> */}
              <div className=" font-semibold my-2 ">URL <AstericSign/></div>
              <FormHookInput
                disabled
                type="text"
                placeholder="URL"
                register={register("clientUrl", {
                  required: "URL is required!",
                })}
                error={errors.clientUrl}
              />
            </div>
            <div className="w-full ">
              {" "}
              <div>
                <div className=" font-semibold my-2 ">Stripe Email <AstericSign/></div>
                <FormHookInput
                  disabled

                  type="email"
                  placeholder="Stripe Email"
                  register={register("stripeEmail", {
                    required: "Stipe email is required!",
                    pattern: emailValidator,
                    onBlur: () => trigger("stripeEmail"),
                  })}
                  error={errors.stripeEmail}
                />
              </div>
            </div>

          </div>
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full ">
              <div className=" font-semibold my-2 ">Main Address <AstericSign/></div>

              <PlacesInput
                disabled
                defaultValue={companyData?.address1}
                onAddressSelected={() => { console.log('') }}
                error={""}
              />
              {error?.name === "address" && (
                <p className="text-red-500 text-xs mt-1 py-">
                  {error?.message}
                </p>
              )}
            </div>
            <div className="w-full ">
              <div className=" font-semibold my-2 ">Address 2 </div>
              <FormHookInput
                disabled

                type="text"
                placeholder="Address 2"
                register={register("address2", {
                  pattern: avoidEmptyStringValidator,
                })}
                error={errors.address2}
              />
            </div>
          </div>


          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full">
              <div className=" font-semibold my-2 ">Postal Code </div>
              <FormHookInput
                disabled

                type="text"
                placeholder="Postal Code"
                register={register("postalCode", {
                  pattern: {
                    value: /^[0-9]{5}(-[0-9]{4})?$/, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                    message: "Invalid Postal Code",
                  },
                  // required: "P is required",
                })}
                error={errors.postalCode}
              />
            </div>
            <div className="w-full ">
              {" "}
              <div>
                <div className=" font-semibold my-2">Google Review Link </div>
                <FormHookInput
                  disabled
                  type="text"
                  placeholder="Google Review Link"
                  register={register("google_review_link", {
                    // onBlur: () => trigger("google_review_link"),
                  })}
                  error={errors.google_review_link}
                />
              </div>
            </div>


          </div>
          <div className="flex gap-4  flex-col sm:flex-row">


            <div className="w-full">
              <div className=" font-semibold my-2 "> Time Zone <AstericSign/></div>

              <SelectSearchInput
                disabled
                placeholder="Select Time Zone"
                options={TIME_ZONES_LIST}
                value={selectTimeZone}
                onChange={selectTimeZoneFun}
              />
              {error?.name === "timezone" && (
                <p className="text-red-500 text-xs mt-1 py-">
                  {error?.message}
                </p>
              )}
            </div>
            <div className="w-full">
              <div className=" font-semibold my-2 ">Stripe ID<AstericSign/></div>
              <FormHookInput
                disabled
                type={"text"}
                placeholder="acct_1032D82eZvKYlo2C"
                register={register("stripeId", {
                  required: "Stripe ID is required",
                  // pattern: {
                  //   value: /^acct_[a-zA-Z0-9]{16}$/, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                  //   message: "Invalid Stripe ID",
                  // },
                })}
                error={errors.stripeId}
              />
            </div>
            <div className="w-full ">
              <div className=" font-semibold my-2 ">Data Id</div>
              <FormHookInput
                disabled

                type="text"
                placeholder="Data Id"
                register={register("data_id", {
                  onChange: (e) => {
                    const { value } = e.target;
                    e.target.value = value;
                  },
                })}
                error={errors.data_id}
              />
            </div>
          </div>
          {/* Min/Max Distance + Cost per mile moved to the Pricing Calculator (PriceCalculation.tsx),
          under the "About your Business" section.
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full">
              <div className=" font-semibold my-2 ">Min Distance (Miles)</div>
              <FormHookInput

                type="text"
                value="30"
                disabled={true}
                placeholder="30-200 Miles"
                register={register("minRadius", {})}
                error={errors.minRadius}
              />
            </div>
            <div className="w-full">
              <div className=" font-semibold my-2 ">Max Distance (miles) <AstericSign/></div>
              <FormHookInput
                disabled

                type="number"
                placeholder="30-200 Miles"
                register={register("radius", {
                  required: "Max Distance is required",
                  pattern: numberWithoutDecimal,
                  max: {
                    value: 200,
                    message: "Max Distance can't be more than 200 miles.",
                  },
                  min: {
                    value: 30,
                    message: "Max Distance can't be less than 30 miles",
                  },
                  onBlur: () => trigger("radius"),
                })}
                error={errors.radius}
              />
            </div>

            {watchedRadius > 30 && (
              <div className="w-full">
                <div className=" font-semibold my-2 ">Cost per mile ($) <AstericSign/></div>
                <FormHookInput
                  disabled
                  type="text"
                  placeholder="Cost per mile"
                  register={register("mileageFee", {
                    required: "Mileage cost is required",
                    pattern: dollarAmountValidation,

                    max: {
                      value: 999,
                      message:
                        "Mileage cost must not exceed the allowable limit",
                    },
                    min: {
                      value: 0,
                      message: "Mileage cost can't be less than 0$",
                    },
                    onBlur: () => trigger("mileageFee"),
                  })}
                  error={errors.mileageFee}
                />
              </div>
            )}
          </div>
          */}
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full">
              <div className=" font-semibold my-2">Facebook</div>
              <FormHookInput
                disabled
                type="text"
                placeholder="Facebook Link"
                register={register("facebook")}
                error={errors.instagram}
              />
            </div>
            <div className="w-full">
              <div className=" font-semibold my-2">Instagram</div>
              <FormHookInput
                disabled
                type="text"
                placeholder="Instagram Link"
                register={register("instagram", {})}
                error={errors.instagram}
              />
            </div>
            <div className="w-full ">
              <div className=" font-semibold my-2">Phone Number <AstericSign/></div>
              <FormHookInput
                type="text"
                disabled
                placeholder="Phone Number"
                register={register("phone_number", {
                  required: "Phone number is required",
                  validate: (value) => {
                    const tel = (value as string)?.replace(
                      NON_DIGIT_REGEX,
                      ""
                    );
                    if (/^1?\d{10}$/.test(tel)) return true;
                    return "Please enter a valid phone number.";
                  },
                })}
                error={errors.phone_number}
              />
            </div>

          </div>

          <div className="flex gap-4 flex-col sm:flex-row">
            <div className="w-full ">
              <div className=" font-semibold my-2 ">Business Description <AstericSign/></div>
              <div className="overflow-hidden">

                <FormHookTextArea
                  type="text"
                  disabled
                  rows={6}
                  placeholder="Description "
                  register={register("description", {
                    pattern: avoidEmptyStringValidator,
                    required: "Description is required",
                    maxLength: {
                      value: 2500,
                      message:
                        "Description length can't be more than 2500 characters.",
                    },
                    onBlur: () => trigger("description"),
                  })}
                  error={errors.description}
                />
              </div>

            </div>
            <div className="w-full ">
              <div className=" font-semibold my-2 ">Custom Quote Description</div>
              <div className="overflow-hidden">
                <FormHookTextArea
                  type="text"
                  disabled
                  rows={6}
                  placeholder="Custom Quote Description"
                  register={register("custom_quote_description", {
                    maxLength: {
                      value: 2500,
                      message:
                        "Description length can't be more than 2500 characters.",
                    },
                  })}
                  error={errors.custom_quote_description}
                />
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  );
};

export default CompanyDetail;
